import baseUniq from "./component-library301.mjs";
function uniq(array) {
  return array && array.length ? baseUniq(array) : [];
}
export {
  uniq as default
};
